import {
  Divider,
  Form,
  type FormItemProps as AntdFormItemProps,
  Typography,
} from 'antd';
import classNames from 'classnames';
import type { ReactNode } from 'react';

interface FormItemProps extends AntdFormItemProps {
  textPreview?: ReactNode;
  isPreviewMode?: boolean;
  isLastFormItem?: boolean;
  isHiddenDivider?: boolean;
  isLabelBold?: boolean;
  isHeightAuto?: boolean;
}

export function FormItem({
  children,
  textPreview,
  rules,
  className,
  isPreviewMode,
  labelCol,
  wrapperCol,
  isLastFormItem,
  isHiddenDivider,
  isLabelBold,
  isHeightAuto,
  ...rest
}: Readonly<FormItemProps>) {
  const wrapperColSpan = isPreviewMode
    ? { span: 24 - Number(labelCol?.span ?? 0) }
    : wrapperCol;

  const formItemClassName = classNames(className, {
    'ant-form-item-label-bold': isLabelBold,
    'ant-form-item-height-auto': isHeightAuto,
    'mb-0 ant-form-item-preview-mode': isPreviewMode,
  });

  const dividerClassName = classNames({ 'mb-0': isLastFormItem });

  return (
    <>
      <Form.Item
        className={formItemClassName}
        rules={isPreviewMode ? [] : rules}
        labelCol={labelCol}
        wrapperCol={wrapperColSpan}
        {...rest}
      >
        {isPreviewMode ? (
          <Typography.Text className="white-space-pre-wrap text-md">
            {textPreview || '-'}
          </Typography.Text>
        ) : (
          children
        )}
      </Form.Item>
      {isPreviewMode && !isHiddenDivider && (
        <Divider className={dividerClassName} />
      )}
    </>
  );
}
